import React from 'react';
import { Form } from 'react-final-form';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { useSelector } from 'hooks/useSelector';
import { signIn } from 'modules/auth/actions';
import { LOGIN_STEPS } from 'modules/auth/constant';
import { getCurrentAuthStep } from 'modules/auth/selectors';
import { getCustomName } from 'modules/users/selectors/currentUser';

import LoginForm from './LoginForm';
import VerifyStep from './VerifyStep';

/** @type React.FC */
const Login = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const customName = useSelector(getCustomName);
  const currentAuthStep = useSelector(getCurrentAuthStep);

  const authenticate = React.useCallback(
    data => {
      const payload = {
        username: data?.userName?.toLowerCase()?.trim(),
        password: data?.password
      };
      dispatch(signIn(payload));
    },
    [dispatch]
  );

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage(
            {
              id: 'app_tab.login',
              defaultMessage: '{name} · Login',
            },
            { name: customName }
          )}
        </title>
      </Helmet>
      {currentAuthStep === LOGIN_STEPS.LOGIN && <Form onSubmit={authenticate} subscription={{}} component={LoginForm} />}
      {currentAuthStep === LOGIN_STEPS.MFA_EMAIL && <VerifyStep />}
    </>
  );
};

export default Login;
